import { Component, OnInit } from '@angular/core';

import { Alarme } from "../shared/alarme.model";
import { alarmeModuleName } from "../shared/data.service";
import { AlarmeApiService } from "../shared/alarme-api.service";
import { AlarmeNavigationService } from "../shared/alarme-navigation.service";
import { Alarmeservice } from "../shared/alarme.service";
import { UtilService } from "../../../shared/services/util.service";
import {rastreamentosModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";
import {RastreamentoService} from "../../shared/rastreamento.service";

@Component({
    template: require('./alarme-list.component.html'),
    styles: [require('./alarme-list.component.css')]
})
export class AlarmeListComponent implements OnInit {
    list: Alarme[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    alarmesModuleName: any = alarmeModuleName;
    module: any = rastreamentosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    typesList: any[] = [];

    constructor(
        private _alarmesApiService: AlarmeApiService,
        private _alarmesService: Alarmeservice,
        private _alarmeNavigationService: AlarmeNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getTypes();
        this.getAll();
    }

    clickNew() {
        this._alarmesService.clearSessionStorage();
        this._alarmeNavigationService.goToNew();
    }

    clickEdit(item: Alarme) {
        this._alarmesService.clearSessionStorage();
        this._alarmeNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    clickDelete(item: Alarme) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }

            if (this.typesList.length) {
                this.setList();
            }
        }.bind(this));

        this._alarmesApiService.onGetPopulate(onDone);
    }

    private getTypes() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.typesList = Response;

                if (this.list.length) {
                    this.setList();
                }
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }

            this.loadingType = false;
        }.bind(this));

        this._alarmesApiService.onGetEvents(onDone);
    }

    private setList() {
        var x: number, lenX: number, y: number, lenY: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
            for (y = 0, lenY = this.typesList.length; y < lenY; y++) {
                if (this.list[x].tipoEvento === this.typesList[y].id) {
                    this.list[x].tipoEvento = this.typesList[y];
                    break;
                }
            }
        }

        this.loading = false;
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._alarmesApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/alarme-list/alarme-list.component.ts
 **/